import { isNullOrUndefined, isNull, isNumber } from 'util';
import moment from "moment";

export class CartOrderApproval extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cart: this.props.cart,
            approvedDate : this.props.approvedDate,
        }
    }

    renderForApprovalMessage() {
        if (!isNullOrUndefined(this.state.cart.orderApproval)) {
            var approvedList = this.state.cart.orderApproval.sort(x => x.createdDate);
            var count = 0;            
            var approverNote = null;
            var lastApproverIndex = approvedList.length;
            if (approvedList && approvedList.length > 0) {

                return approvedList.map((approval) => {
                    if (!isNullOrUndefined(approval.noteForApprover)) {
                        approverNote = <h6>NOTE: <small>{approval.noteForApprover}</small></h6>;
                    }

                    var editedBy = null;
                    var approvedBy = null;

                    if (!isNullOrUndefined(approval.editDate)) {
                        approvingContact = approval.approvingContact.displayName == null ? "" : approval.approvingContact.displayName;

                        editedBy =
                            <div className="alert alert-info"> {moment(approval.editDate)
                                .format('Do MMMM YYYY [at] h:mma')} {approvingContact} edited the order </div>;
                    }


                    if (!isNullOrUndefined(approval.rejectDate)) {
                        var approvingContact = approval.approvingContact.displayName == null ? "" : approval.approvingContact.displayName;


                        editedBy =
                            <div className="alert alert-info"> {moment(approval.rejectDate)
                                .format('Do MMMM YYYY [at] h:mma')} {approvingContact} rejected the order <hr/>{
                                    approval.rejectReason}</div>;
                    }

                    count++;

                    //if (!isNullOrUndefined(this.props.cart.completedOrderId) &&
                    //    this.props.cart.completedOrderId != 0 &&
                    //    lastApproverIndex == count) {
                    //    var lastApprover = approval.approvingContact.displayName;

                    //    var approvedDate = null;
                    //    if (!isNullOrUndefined(approval.approvedDate)) {
                    //        approvedDate = approval.approvedDate;
                    //    } else {
                    //        approvedDate = this.state.approvedDate;
                    //    }

                    //    if (approvedDate != null && lastApprover != "") {
                    //        approvedBy =
                    //            <div className="alert alert-info"> {moment(approvedDate)
                    //                .format('Do MMMM YYYY [at] h:mma')} {lastApprover} approved the order </div>;
                    //    }

                    //}


                    if (!isNullOrUndefined(approval.approvedDate)) {
                        var lastApprover = approval.approvingContact.displayName == null ? "" : approval.approvingContact.displayName;

                        if (!isNullOrUndefined(lastApprover) || lastApprover != "") {
                            approvedBy =
                                <div className="alert alert-info"> {moment(approval.approvedDate)
                                    .format('Do MMMM YYYY [at] h:mma')} {lastApprover} approved the order </div>;
                        }
                    }
                    var name = "";
                    if (approval != null && approval.contactInformation != null) {
                        name = approval.contactInformation.displayName;
                    }

                    if (count > 1) {
                        return <div key={approval.id}>
                                   <div className="alert alert-info">
                                       {moment(approval.createdDate).format('Do MMMM YYYY [at] h:mma')} {name} sent the order for futher approval
                                   </div>
                                   {editedBy}
                                   {approvedBy}
                               </div>;
                    } else {
                        return <div key={approval.id}>
                                   <div className="alert alert-info">
                                       {moment(approval.createdDate).format('Do MMMM YYYY [at] h:mma')} {name} sent the order for approval
                                       {approverNote}
                                   </div>
                                   {editedBy}
                                   {approvedBy}
                               </div>;
                    }
                });
            }
        }
    }

    render() {
        return <div>
            {this.renderForApprovalMessage()}
        </div>
    }
}